import { DEFAULT_LANGUAGE, type Language } from '@lexicon/core';
import { en } from './en';
import { nl } from './nl';

/**
 * The shape of a language's copy, derived from the English table.
 *
 * English is the source of truth by construction rather than by
 * convention: every other table is typed as `Strings`, so a new line in
 * `en.ts` fails to compile in `nl.ts` until it is translated. That is the
 * whole mechanism — there is no key lookup, no partial table and no
 * silent fallback to English at runtime.
 */
export type Strings = typeof en;

export const STRINGS: Readonly<Record<Language, Strings>> = { en, nl };

/** The copy for a language. Never null — every language has a full table. */
export function stringsFor(language: Language = DEFAULT_LANGUAGE): Strings {
  return STRINGS[language];
}
